import {
  SET_CONFIG_INFO,
  FETCH_ACCOUNT_LIST,
  FETCH_ACCOUNT_LIST_SUCCESS,
  FETCH_ACCOUNT_LIST_FAILED,
  GET_USER_DETAILS,
  GET_USER_DETAILS_SUCCESS,
  GET_USER_DETAILS_FAILURE,
  GET_CMA_DETAILS,
  GET_CMA_DETAILS_SUCCESS,
  GET_CMA_DETAILS_FAILURE,
  UPDATE_CMA_DETAILS,
  UPDATE_CMA_DETAILS_SUCCESS,
  UPDATE_CMA_DETAILS_FAILURE,
  TOGGLE_MODAL,
  CLOSE_MODAL,
  SET_USER_INFO,
  SET_SELECTED_ACCOUNT_ID,
  THRESHOLD_VALIDATION_MESSAGE,
  TARGET_VALIDATION_MESSAGE,
  GET_SAVING_ACCOUNT_ID,
  ALERT_VALIDATION_MESSAGE,
  TRANSACTION_VALIDATION_MESSAGE,
  ENABLE_EDIT_MODE,
  ENABLE_UNSAVED_LEAVE_POPUP,
  SET_SOURCE_TYPE,
  GET_SELECTED_ACCOUNT_DETAILS,
  GET_SELECTED_ACCOUNT_DETAILS_SUCCESS,
  GET_SELECTED_ACCOUNT_DETAILS_FAILURE,
} from '../../constants/actionTypes';
import {
  ACCOUNT_LIST_ENDPOINT,
  USER_DETAILS_ENDPOINT,
  GET_CMA_DETAILS_ENDPOINT,
  GET_ACCOUNT_DETAILS_ENDPOINT,
} from '../../constants/urls';
import { RSAA } from 'redux-api-middleware';
import { X_BPI_VERSION_0_8_0 } from '../../constants/VersionConstants';

export const setConfigInfo = (payload) => ({
  type: SET_CONFIG_INFO,
  payload,
});
export const setUserInfo = (payload) => ({
  type: SET_USER_INFO,
  payload,
});
export const setSourceType = (payload) => ({
  type: SET_SOURCE_TYPE,
  payload,
});
export const setSelectedAccountId = (payload) => ({
  type: SET_SELECTED_ACCOUNT_ID,
  payload,
});

export const fetchAccountList = () => ({
  [RSAA]: {
    endpoint: ACCOUNT_LIST_ENDPOINT,
    method: 'GET',
    types: [FETCH_ACCOUNT_LIST, FETCH_ACCOUNT_LIST_SUCCESS, FETCH_ACCOUNT_LIST_FAILED],
  },
});

export const getCMAAlert = (data) => ({
  [RSAA]: {
    endpoint: GET_CMA_DETAILS_ENDPOINT.replace('{account_id}', data),
    method: 'GET',
    headers: {
      'x-bpi-version': X_BPI_VERSION_0_8_0,
    },
    types: [GET_CMA_DETAILS, GET_CMA_DETAILS_SUCCESS, GET_CMA_DETAILS_FAILURE],
  },
});

export const updateCMAAlert = (data, reqBody) => ({
  [RSAA]: {
    endpoint: GET_CMA_DETAILS_ENDPOINT.replace('{account_id}', data.account_id),
    method: 'PUT',
    headers: {
      'x-bpi-version': X_BPI_VERSION_0_8_0,
    },
    body: JSON.stringify(reqBody),
    types: [UPDATE_CMA_DETAILS, UPDATE_CMA_DETAILS_SUCCESS, UPDATE_CMA_DETAILS_FAILURE],
  },
});

export const getUserDetails = () => ({
  [RSAA]: {
    endpoint: USER_DETAILS_ENDPOINT,
    method: 'GET',
    types: [GET_USER_DETAILS, GET_USER_DETAILS_SUCCESS, GET_USER_DETAILS_FAILURE],
  },
});

export const toggleModal = (isOpen, overDraftType) => ({
  type: TOGGLE_MODAL,
  isOpen,
  overDraftType,
});

export const closeErrorPopup = (updateOverdraftError) => ({
  type: CLOSE_MODAL,
  updateOverdraftError,
});
export const showThresholdError = (showThresholdError) => ({
  type: THRESHOLD_VALIDATION_MESSAGE,
  showThresholdError,
});
export const showTargetError = (showTargetError) => ({
  type: TARGET_VALIDATION_MESSAGE,
  showTargetError,
});
export const setSelectedSavingsAccountID = (savingAccountID) => ({
  type: GET_SAVING_ACCOUNT_ID,
  savingAccountID,
});
export const showAlertsError = (showAlertError, validationKey) => ({
  type: ALERT_VALIDATION_MESSAGE,
  showAlertError,
  validationKey,
});
export const showTransactionAmountError = (transactionAmountValidation) => ({
  type: TRANSACTION_VALIDATION_MESSAGE,
  transactionAmountValidation,
});
export const editModeEnabled = (enableEditMode) => ({
  type: ENABLE_EDIT_MODE,
  enableEditMode,
});
export const showUnsavedLeavePopup = (enableUnsavedLeavePopup) => ({
  type: ENABLE_UNSAVED_LEAVE_POPUP,
  enableUnsavedLeavePopup,
});
export const getSelectedAccountDetails = (data) => ({
  [RSAA]: {
    endpoint: GET_ACCOUNT_DETAILS_ENDPOINT.replace('{account_id}', data),
    method: 'GET',
    headers: {
      'x-bpi-version': X_BPI_VERSION_0_8_0,
    },
    types: [
      GET_SELECTED_ACCOUNT_DETAILS,
      GET_SELECTED_ACCOUNT_DETAILS_SUCCESS,
      GET_SELECTED_ACCOUNT_DETAILS_FAILURE,
    ],
  },
});
